import BaseComponent from "@js/components/base_component.jsx";

import Select2 from "@js/components/widgets/select2.jsx";

class SelectSelector extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.selectedValue,
      selectedName: props.selectedName,
      dropdownIsOpen: false,
      styleWidth: 250,
    };
  }

  render() {
    return this.state.dropdownIsOpen ? (
      <div
        ref={(n) => { this._rootNode = n; }}
        style={{ marginLeft: "10px", display: "inline-block", position: "relative", marginTop: "-12px" }}
      >
        <Select2
          value={ this.state.selectedValue }
          onChange={ this._onSelectValue }
          onBlur={ this._onBlur }
          options={ this.props.options }
          optionsGrouped={ this.props.optionsGrouped }
          width={ `${this.state.styleWidth}px` }
          select2StartOpen={ true }
        />
      </div>
    ) : (
      <div
        ref={(n) => { this._rootNode = n; }}
        className="daterange-selector"
        onClick={ this._showDropdown }
      >
        <FaIcon name="object-group fa-lg indicator" />
        &nbsp;&nbsp;
        <span className="prefix"> { this.props.prefix } </span>
        &nbsp;&nbsp;
        <span className="value">{ this._selectedDescription() }</span>
        &nbsp;&nbsp;
        <FaIcon name="caret-down fa-lg" />
      </div>
    );
  }

  _showDropdown() {
    let width = $(this._rootNode).outerWidth(true);
    if ( width < 250 ) width = 250;

    this.setState({
      dropdownIsOpen: true,
      styleWidth: width,
    });
  }

  _onSelectValue(value, name) {
    this.setState({
      dropdownIsOpen: false,
      selectedValue: value,
      selectedName: name,
    }, () => {
      this.props.onChange(value, name);
    });
  }

  _onBlur() {
    this.setState({
      dropdownIsOpen: false,
    });
  }

  _selectedDescription() {
    return this.state.selectedName ? (
      this.state.selectedName
    ) : (
      this.props.defaultName
    );
  }

}

export default SelectSelector;
